<template>
  <section class="py-5 backgroundfifth t1-section-px" id="why-us">
    <div class="container-lg">
      <div class="row row-gap-lg align-items-center">
        <div class="col-lg-6" data-aos="fade-right">
          <div class="eyebrow textmain mb-2">Why shippers stay</div>
          <h2 class="font-weight-bold mb-3">Straight rates, on-time hauls, freight handled right</h2>
          <p class="text-muted mb-4">
            We run every load how it should be run: show up on time, quote it
            honestly, and stand behind it all the way to delivery.
          </p>

          <ul class="list-unstyled">
            <li v-for="item in reasons" :key="item.title" class="d-flex mb-3 ">
              <i class="bi bi-check-circle-fill textsuccess mr-2 mt-1"></i>
              <div>
                <strong>{{ item.title }}</strong>
                {{ item.detail }}
              </div>
            </li>
          </ul>
        </div>

        <div class="col-lg-6 mt-4 mt-lg-0" data-aos="fade-left">
          <div class="row row-gap-sm">
            <div class="col-6 mb-4" v-for="stat in stats" :key="stat.label">
              <div class="card border-0 h-100 text-center p-3 backgroundwhite emd-shadow-md">
                <div class="h2 font-weight-bold textmain mb-1">{{ stat.value }}</div>
                <div class="text-muted small">{{ stat.label }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Theme1HomePagePart3WhyUs',
  props: {
    reasons: {
      type: Array,
      default: () => [
        { title: 'Upfront freight rates.', detail: 'You approve the rate before the load is booked — no surprise accessorials.' },
        { title: 'Licensed & bonded.', detail: 'Current DOT authority, cargo insurance, and bonding on every load we haul.' },
        { title: 'Live dispatch.', detail: 'Text and GPS-tracked updates from pickup to delivery, on every run.' },
        { title: 'On-time guarantee.', detail: 'Miss a pickup or delivery window on us, and we make it right at no charge.' },
      ],
    },
    stats: {
      type: Array,
      default: () => [
        { value: '18+', label: 'Years in business' },
        { value: '9,400+', label: 'Loads delivered' },
        { value: '< 2 hrs', label: 'Avg. dispatch response' },
        { value: '4.9 / 5', label: 'Customer rating' },
      ],
    },
  },
};
</script>
